import React from "react";

function ModifyWaterReport() {
  return (
    <div>
      <h1>修改水质分析报告</h1>
      <p>TO DO</p>
    </div>
  );
}

export default ModifyWaterReport;
